import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

/**
 * Use placement prop to decide the side tooltips needs to be render.
 */

const TwTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#171E28'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#171E28',
    fontFamily: 'Poppins',
    fontSize: '12px',
    lineHeight: '16.8px',
    color: '#fff',
    padding: '10px',
    opacity: '0.9',
    whiteSpace: 'pre-wrap'
  }
}));

export default TwTooltip;
